import * as React from "react";
type Props = {
  className?: string,
};
function SvgVegan({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Vegan"
      className={className}
    >
      <path
        d="M15.1295 38.5714C11.9123 26.4537 1.42859 19.7161 1.42859 19.7161M15.1138 38.4218C15.3514 23.8384 30.3001 4.24322 30.3001 4.24322M23.5088 14.2855C25.3374 1.81001 12.3394 1.42859 12.3394 1.42859C11.1636 13.9724 23.5088 14.2855 23.5088 14.2855ZM21.1466 19.19C30.2873 28.2269 38.5714 18.5999 38.5714 18.5999C28.9729 10.0164 21.1466 19.19 21.1466 19.19Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgVegan;
